import "../../../assets/css/overlay.css";
import { useEffect, useRef, useState } from "react";
import { actualRatingYesNoValue, getSurveyLinkState, giveSurveyLinkStatusMessage, surveys } from "../../../utils/utils";
import PublicHeader from "./PublicHeader.jsx";
import SimpleReactValidator from "simple-react-validator";
import Loader from "../../../components/loader";
import SurveyService from "../../../services/SurveyService";
import InputYesNo from "../../inputs/InputYesNo";
import InputRating from "../../inputs/InputRating";
import InputText from "../../inputs/InputText";
import { useParams } from "react-router";
import CohortService from "../../../services/CohortService";

const initialState = {
    cohortId: null,
    accountAccId: null,
    cohortSurveyLinkId: null,
    cohortParticipantId: null,
    participantEmail: null,
    q1Rating: null,
    q2Rating: null,
    q3Rating: null,
    q4Rating: null,
    q5Rating: null,
    q6YesNo: null,
    q7Rating: null,
    q8YesNo: null,
    q10Text: null,
    q9Text: null,
};

const WellnessSurvey = () => {
    const [feedbackQuestions, setFeedbackQuestions] = useState({
        ...initialState,
    });
    const validator = useRef(new SimpleReactValidator());
    const [_, setForceUpdate] = useState(false);
    const [isShowLoader, setShowLoader] = useState(false);
    const [showMessage, setShowMessage] = useState({ isShowMessage: false, isLinkValid: false, isFormSubmitted: false, isLinkSubmitted: false, isShowForm: false });
    const { token } = useParams();

    useEffect(async () => {
        setShowLoader(true);
        try {
            const checkSurveyLinkResponse = await CohortService().checkCohortSurveyLink(token);
            const checkCohortSurveyLinkData = checkSurveyLinkResponse.data.data;
            if (checkSurveyLinkResponse.status == 200) {
                const linkState = getSurveyLinkState(checkCohortSurveyLinkData, surveys.wellness)
                setShowMessage(prevState => {
                    return { ...prevState, ...linkState };
                });

                if (!linkState.isShowMessage) {
                    setFeedbackQuestions(prevState => {
                        return {
                            ...prevState, accountAccId: checkCohortSurveyLinkData.accountId,
                            cohortId: checkCohortSurveyLinkData.cohortId, cohortSurveyLinkId: checkCohortSurveyLinkData.cohortSurveyLinkId,
                            cohortParticipantId: checkCohortSurveyLinkData.cohortParticipantId, participantEmail: checkCohortSurveyLinkData.participantEmail
                        }
                    })
                }
            }
        } catch (error) {
            console.debug(error);
            setShowMessage(prevState => {
                return { ...prevState, isShowMessage: true, isLinkValid: true }
            })
        }
        setShowLoader(false);

    }, []);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFeedbackQuestions((prevState) => {
            return { ...prevState, [name]: value };
        });
    };

    const handleRatingChange = (event, isRatingYesNo = false) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isRatingYesNo) {
            value = actualRatingYesNoValue[value];
        }
        value = value == feedbackQuestions[name] ? null : value;
        setFeedbackQuestions((prevState) => {
            return { ...prevState, [name]: value };
        });
    }


    const submitFeedback = async (e) => {
        if (!validator.current.allValid()) {
            validator.current.showMessages();
            setForceUpdate((prevState) => !prevState)
            return;
        }
        setShowLoader(true);
        await SurveyService()
            .saveWellnessSurvey(feedbackQuestions);
        setShowMessage((prevState) => {
            return { ...prevState, isShowMessage: true, isFormSubmitted: true }
        });
        setShowLoader(false);
    };

    return (
        <>
            {isShowLoader &&
                <div className="overlay">
                    <Loader loading={isShowLoader} />
                </div>
            }
            <PublicHeader />
            <div className="wrapper">
                <section className="simulation-header p-0">
                    <h3 className="title">Wellness Survey</h3>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    {(!showMessage.isShowMessage && showMessage.isShowForm) &&
                                        <div className="card-body">
                                            <InputRating
                                                label="How would you rate your overall well-being this week?"
                                                inputName="q1Rating"
                                                state={feedbackQuestions.q1Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="How supported do you feel by your administration and colleagues?"
                                                inputName="q2Rating"
                                                state={feedbackQuestions.q2Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="How manageable has your workload felt this week?"
                                                inputName="q3Rating"
                                                state={feedbackQuestions.q3Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="How often have you felt overwhelmed or stressed this week?"
                                                inputName="q4Rating"
                                                state={feedbackQuestions.q4Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="Have you been able to maintain a healthy work-life balance?"
                                                inputName="q5Rating"
                                                state={feedbackQuestions.q5Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputYesNo
                                                label="Have you experienced significant stress, anxiety, or burnout this week?"
                                                inputName="q6YesNo"
                                                state={feedbackQuestions.q6YesNo}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="How often have you felt engaged and motivated in your role this week?"
                                                inputName="q7Rating"
                                                state={feedbackQuestions.q7Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />


                                            <InputYesNo
                                                label="Have you accessed any mental health or self-care resources this week?"
                                                inputName="q8YesNo"
                                                state={feedbackQuestions.q8YesNo}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputText
                                                label="What was the biggest challenge you faced this week?"
                                                inputName="q9Text"
                                                state={feedbackQuestions.q9Text}
                                                handleChange={handleChange}
                                                validator={validator}
                                            />

                                            <InputText
                                                label="Is there anything that would help improve your well-being at work?"
                                                inputName="q10Text"
                                                state={feedbackQuestions.q10Text}
                                                handleChange={handleChange}
                                                validator={validator}
                                            />

                                            <div className="form-group row">
                                                <div className="col-sm-12 text-center">
                                                    <button
                                                        type="button"
                                                        className="btn white float-right"
                                                        onClick={submitFeedback}
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {showMessage.isShowMessage &&
                                        <div className="card-body text-center">
                                            <h3>{giveSurveyLinkStatusMessage(showMessage)}</h3>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default WellnessSurvey;